<template>
    <label class="block">
        <span v-if="label" class="block text-sm text-white/70 mb-1">{{ label }}</span>
        <input
            ref="inputRef"
            :type="type ?? 'text'"
            :value="modelValue"
            :autocorrect="autocorrect"
            :autocapitalize="autocapitalize"
            :required="required"
            class="w-full bg-surface-card text-white border-0 border-b border-white/30 px-2 py-2 focus:border-primary focus:outline-none"
            @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
        />
    </label>
</template>

<script setup lang="ts">
    import { ref } from 'vue'

    defineProps<{
        modelValue: string
        type?: string
        label?: string
        autocorrect?: 'on' | 'off'
        autocapitalize?: 'off' | 'on' | 'none'
        required?: boolean
    }>()

    defineEmits<{
        'update:modelValue': [value: string]
    }>()

    const inputRef = ref<HTMLInputElement | null>(null)
    defineExpose({ focus: () => inputRef.value?.focus() })
</script>
